"use strict";

var isArray = require('../is/array');
var isArrayLike = require('../is/arrayLike');
/**
 * Converts val to array. If val is array return it.
 * @param {*} val
 * @return {Array}
 * @example
 *
 *      toArray([1,2,3]) // => [1,2,3]
 *      toArray(5) // => [5]
 *      toArray('test') // => ['test']
 */
module.exports = function (val) {
  if (isArray(val)) {
    return val;
  }
  if (isArrayLike(val)) {
    return Array.prototype.slice.call(val);
  }
  return [val];
};